import React, {useMemo} from 'react'
import {RefundAmount as Refund} from 'app/features/orders/componentsv1/edit'
import {
  selectDeletedItems,
  selectRefund,
  selectViewOrder,
  selectViewOrderPaymentMethod,
  setOrderRefundPrice,
} from 'app/features/orders/redux/order/refundSlice'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {RefundOrder} from 'app/features/orders/models/OrderRefundState'
import capitalize from 'lodash/capitalize'
import {ViewOrder} from 'app/features/orders/models/OrderState'

export const RefundAmount: React.FC = () => {
  const dispatch = useDispatch()
  const refund = useSelector<RootState, RefundOrder>(selectRefund)
  const paymentMethod = useSelector<RootState, any>(selectViewOrderPaymentMethod)
  const items = useSelector<RootState, any[]>(selectDeletedItems)
  const viewOrder = useSelector<RootState, ViewOrder>(selectViewOrder)

  const handleAmountChange = (amount: number | any) => {
    dispatch(setOrderRefundPrice(amount))
  }

  const maxRefundPrice = useMemo(() => {
    if (items.length) {
      return refund.totalPrice
    }
    return viewOrder.totalPrice
  }, [items.length, refund.totalPrice, viewOrder.totalPrice])

  const pm = useMemo(() => {
    if (paymentMethod && paymentMethod.card) {
      const {brand, last4} = paymentMethod.card
      return {title: `To ${capitalize(brand)} Ending ${last4}`, brand}
    }
    return {title: 'To Your Payment Method', brand: null}
  }, [paymentMethod])

  if (refund.totalPrice < 0 || items.length === 0) {
    return null
  }

  return (
    <Refund
      {...pm}
      onAmountChange={handleAmountChange}
      refundPrice={refund.orderRefundPrice}
      maxRefundPrice={maxRefundPrice}
    />
  )
}

export default RefundAmount
